import * as React from 'react';
export const importSvg = React.forwardRef(function importSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.75 3.25C8.75 2.56 9.31 2 10 2h3a.75.75 0 0 0 0-1.5h-3a2.75 2.75 0 0 0-2.75 2.75v6.19L5.03 7.22a.75.75 0 0 0-1.06 1.06l3.535 3.536a.75.75 0 0 0 1.06 0l3.536-3.536a.75.75 0 1 0-1.06-1.06L8.75 9.51V3.25Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.25 11a.75.75 0 0 1 .75.75V14h12v-2.25a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75H1.25a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .75-.75Z',
    }),
  );
});
importSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var importIcon = {
  category: 'icon',
  colorable: true,
  name: 'import',
  svg: importSvg,
};
